import {
  DataModel,
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../dto/data-model.js';
import { AuditLogEntry } from '../audit-log-entry.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import {
  cloneData, isSameData,
} from '../../../dto/data-model-utils.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { GenericOrder } from '../../orders/generic-order.js';

export class GenericOrderCreatedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '6cfef9426ae7473e9246d8ce7354bf67';

  private constructor(
      public readonly order: GenericOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return GenericOrderCreatedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.GenericOrderCreated;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.order.businessRef.encode(),
      orderId: this.order.uniqueId,
      customerId: this.order.creatorId,
      isGuestOrder: this.order.isGuestOrder,
    };
  }

  static create(args: {
      order: GenericOrder,
  }): GenericOrderCreatedEntry {
    return new GenericOrderCreatedEntry(
        args.order,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): GenericOrderCreatedEntry {
    return this.create({
      order: context.fromData(MapUtils.getRecord(map, 'order')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      order: context.toData(this.order),
    };
  }

  clone(): this {
    return GenericOrderCreatedEntry.create({
      order: cloneData(this.order),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.order, this.order);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof GenericOrderCreatedEntry;
  }

  static assertType(dm: DataModel): dm is GenericOrderCreatedEntry {
    return dm instanceof GenericOrderCreatedEntry;
  }
}

export class GenericOrderCreatedEntryBuilder extends DataModelBuilder<GenericOrderCreatedEntry> {
  build(context: SerializationContext, map: SerializedData): GenericOrderCreatedEntry {
    return GenericOrderCreatedEntry.fromMap(context, map);
  }
}
